import Vue from 'vue'

import {
  LayoutPlugin,
  BreadcrumbPlugin,
  BadgePlugin,
  ButtonPlugin,
  IconsPlugin,
  CardPlugin,
  FormCheckboxPlugin,
  FormInputPlugin,
  InputGroupPlugin,
  CollapsePlugin,
  AvatarPlugin,
  ProgressPlugin,
  SpinnerPlugin,
  ImagePlugin,
  ModalPlugin,
  TabsPlugin,
  FormRadioPlugin,
  TooltipPlugin,
  FormPlugin,
  EmbedPlugin,
  SkeletonPlugin
} from 'bootstrap-vue'

Vue.use(LayoutPlugin)
Vue.use(BreadcrumbPlugin)
Vue.use(BadgePlugin)
Vue.use(ButtonPlugin)
Vue.use(IconsPlugin)
Vue.use(CardPlugin)
Vue.use(AvatarPlugin)
Vue.use(ProgressPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormInputPlugin)
Vue.use(InputGroupPlugin)
Vue.use(CollapsePlugin)
Vue.use(SpinnerPlugin)
Vue.use(ImagePlugin)
Vue.use(ModalPlugin)
Vue.use(TabsPlugin)
Vue.use(FormRadioPlugin)
Vue.use(TooltipPlugin)
Vue.use(FormPlugin)
Vue.use(EmbedPlugin)
Vue.use(SkeletonPlugin)
